import React from "react";

const StatusBadge = ({ status }) => {
  if (!status) return null;

  const normalizedStatus = status.toLowerCase();

  const statusStyles = {
    placed: { border: "1px solid #fbb040", color: "#fbb040", label: "In Process" },
    inprocess: { border: "1px solid #fbb040", color: "#fbb040", label: "In Process" },
    accepted: { border: "1px solid #fbb040", color: "#fbb040", label: "Confirmed" },
    shipped: { border: "1px solid #fbb040", color: "#fbb040", label: "Confirmed" },
    lpaccepted: { border: "1px solid #fbb040", color: "#fbb040", label: "Confirmed" },
    outfordelivery: {
      border: "1px solid #3a00f7ff",
      color: "#3a00f7ff",
      label: "Out For Delivery",
    },
    delivered: { border: "1px solid #259B24", color: "#259B24", label: "Order Delivered" },
    cancelled: { border: "1px solid #E53935", color: "#E53935", label: "Cancelled" },
    default: { border: "1px solid #372a16ff", color: "#fbb040", label: status },
  };

  const style = statusStyles[normalizedStatus] || statusStyles.default;

  return (
    <span
      className="px-2 py-1"
      style={{
        border: style.border,
        borderRadius: "5px",
        color: style.color,
        fontSize: "0.8rem",
        whiteSpace: "nowrap",
      }}
    >
      {style.label.charAt(0).toUpperCase() + style.label.slice(1)}
    </span>
  );
};

export default StatusBadge;
